// extracted by mini-css-extract-plugin
export default {"mainForm":"Authentication_mainForm__lloB4","form":"Authentication_form__yqzIG","bottom":"Authentication_bottom__7w0RM","google":"Authentication_google__3nSLx"};